<template>
  <v-row>
    <v-col cols="12" md='5' class="pb-0">
      <v-row>
        <v-card-title class="card-title-res-complex">
          Жилой комплекс {{ resResidentComplex.name }}
        </v-card-title>
      </v-row>
      <v-col cols="8" class="py-0 mt-2 mb-4">
        <div class="count-device">
          <div style="margin-right: 15px;">Домофоны: {{ doorphoneCount }}</div>
          <div style="margin-right: 15px;">Калитки: {{ gateCount }}</div>
          <div>Шлагбаумы: {{ barrierCount }}</div>
        </div>
      </v-col>
      <v-row>
        <v-col cols="10" class="py-0 mt-5">
          <v-textarea
            rows="3"
            v-model="comment"
            bg-color="grey-lighten-2"
            color="cyan"
            label="Комментарий"
            prepend-icon="mdi-comment"
            row-height="30"
            auto-grow
            :disabled="!isDisableComment"
          >
          </v-textarea>
        </v-col>
        <v-card-actions v-if="isDisableComment">
          <div class="my-2 mt-4">
            <v-btn
              large
              color="green"
              class="text-none"
              outlined
              dense
              @click="validate"
            >
              Сохранить
            </v-btn>
            <v-btn
              large
              class="ma-2 text-none"
              outlined
              dense
              hide-details
              color="error"
              @click="cancellation"
            >
              Отмена
            </v-btn>
          </div>
        </v-card-actions>
      </v-row>
    </v-col>
    <v-col class="pb-0">
      <v-card>
        <v-tabs v-model="activeTab">
          <v-tab>Привязанные Домофоны</v-tab>
          <v-tab>Привязанные Шлагбаумы</v-tab>
          <v-tab-item>
            <v-card-title class="pa-0">
              <v-col cols="6" md='5'>
                <v-text-field
                  v-model="filterAddressDoorphone"
                  label="Поиск по адресу"
                  class="pa-3"
                  outlined
                  dense
                  prepend-inner-icon="mdi-rename-box-outline"
                  autocomplete="chrome-off"
                  hide-details
                  clearable
                ></v-text-field>
              </v-col>
            </v-card-title>
            <v-data-table
              class="table"
              :headers="headersDoorphonesTied"
              :items="filteredDoorphones"
              :footer-props="{
                'items-per-page-options': [10, 20],
              }"
              :disable-sort="true"
            >
              <template v-slot:item.address="{ item }">
                <div v-if="$canRoute('DetailDoorphone')">
                  <router-link class="routerLink" :to="`/doorphones/${item.id}`">
                    {{ item.address }}
                  </router-link>
                </div>
                <div v-else>
                    {{ item.address }}
                </div>
              </template>
              <template v-slot:item.type="{ item }">
                <div v-if="item.type === 'M'">Домофон</div>
                <div v-if="item.type === 'G'">Калитка</div>
                <div v-if="item.type === 'A'">Доп.вход</div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      text
                      :disabled="!$checkPermission('open_door_doorphone')"
                      small
                      v-bind="attrs"
                      v-on="on"
                      color="#1E6CEB"
                      class="text-none btn__icon ml-1 mr-1"
                      width="18"
                      height="18"
                      @click="openDoorClick(item)"
                    >
                      <v-icon color="green">mdi-location-exit</v-icon>
                    </v-btn>
                  </template>
                  <span>Открыть</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-tab-item>

          <v-tab-item>
            <v-card-title class="pa-0">
              <v-col cols="12" sm="8" md="5" lg="5" xl="5">
                <v-text-field
                  v-model="filterAddressBarrier"
                  label="Поиск по адресу"
                  class="pa-3"
                  outlined
                  dense
                  prepend-inner-icon="mdi-rename-box-outline"
                  autocomplete="chrome-off"
                  hide-details
                  clearable
                ></v-text-field>
              </v-col>
              <base-toggle-status-barriers
                :barriers="resResidentComplex.barriers"
                @getResidentComplex="getResidentComplex"
              />
            </v-card-title>
            <v-data-table
              class="table"
              :headers="headersBarriersTied"
              :items="filteredBarriers"
              :footer-props="{
                'items-per-page-options': [10, 20],
              }"
              :disable-sort="true"
            >
              <template v-slot:item.status_condition="{ item }">
                <div v-if="item.status_condition === 'on'" style="color: #388E3C">Включено</div>
                <div v-if="item.status_condition === 'off'" style="color: crimson">Выключено</div>
              </template>
              <template v-slot:item.openingType="{ item }">
                <div>{{ getOpeningType(item.opening_type) }}</div>
              </template>
              <template v-slot:item.address="{ item }">
                <div v-if="$canRoute('DetailDoorphone')">
                  <router-link class="routerLink" :to="`/barrier/${item.id}`">
                    {{ item.address }}{{ getPassageType(item.type) }}
                  </router-link>
                </div>
                <div v-else>
                  {{ item.address }}{{ getPassageType(item.type) }}
                </div>
                <span v-if="!item.device_id">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      width="18"
                      height="18"
                    >
                      <v-icon x-small color="orange">mdi-checkbox-blank-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Старый шлагбаум</span>
                </v-tooltip>
              </span>
              </template>
              <template v-slot:item.sip_status="{ item }">
                <div>
                  <v-icon x-small :color="item.sip_status_color">
                    mdi-checkbox-blank-circle
                  </v-icon>
                  {{ item.sip_status_text }}
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      :disabled="!$checkPermission('open_door_doorphone')"
                      text
                      small
                      v-bind="attrs"
                      v-on="on"
                      color="#1E6CEB"
                      class="text-none btn__icon ml-1 mr-1"
                      width="18"
                      height="18"
                      @click="openDeviceClick(item)"
                    >
                      <v-icon color="green">mdi-location-exit</v-icon>
                    </v-btn>
                  </template>
                  <span>Открыть</span>
                </v-tooltip>

                <v-dialog v-model="showDialogTwoButtons[item.id]" max-width="400" content-class="dialog-border-radius">
                  <v-card class="pa-2">
                    <v-card-title class="text-h5">Выберите реле для открытия</v-card-title>
                    <v-card-text>
                      Пожалуйста, выберите реле, которое нужно открыть.
                    </v-card-text>
                    <v-card-actions style="display: block; text-align: center">
                      <v-btn color="primary" @click="handleOpen(1, item.id)">Открыть Реле 1</v-btn>
                      <v-btn color="primary" @click="handleOpen(2, item.id)">Открыть Реле 2</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseToggleStatusBarriers from '@/components/residentComplex/BaseToggleStatusBarriers';

export default {
  name: 'InformationResidentComplex',
  components: { BaseToggleStatusBarriers },
  props: ['id'],
  data: () => ({
    resResidentComplex: [],
    filterAddressDoorphone: '',
    filterAddressBarrier: '',
    comment: '',
    isDisableComment: false,
    showDialogTwoButtons: {},
    options: {
      itemsPerPage: 10,
    },
    activeTab: 0,
    headersDoorphonesTied: [
      { text: 'id', value: 'id' },
      { text: 'Адрес', value: 'address' },
      { text: 'Тип', value: 'type' },
      { text: '', value: 'actions', width: '10%', align: 'center' },
    ],
    headersBarriersTied: [
      { text: 'id', value: 'id' },
      { text: 'Адрес', value: 'address' },
      { text: 'Статус грз', value: 'status_condition' },
      { text: 'sip статус', value: 'sip_status' },
      { text: 'Тип открытия', value: 'openingType' },
      { text: '', value: 'actions', width: '10%', align: 'center' },
    ],
  }),
  created () {
    this.getResidentComplex();
    switch (this.roleName) {
      case 'admin' : case 'admin-engineer' : this.isDisableComment = true;
        break;
    }
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
      doorphones: 'Doorphone/mapDoorphones',
    }),
    filteredDoorphones () {
      let doorphones = this.resResidentComplex.doorphones || [];

      // Фильтрация домофонов по адресу
      if (this.filterAddressDoorphone) {
        doorphones = doorphones.filter(item => {
          return item.address.toString().toLowerCase().includes(this.filterAddressDoorphone.toLowerCase());
        });
      }

      return doorphones;
    },
    filteredBarriers () {
      let barriers = this.resResidentComplex.barriers || [];

      // Фильтрация шлагбаумов по адресу
      if (this.filterAddressBarrier) {
        barriers = barriers.filter(item => {
          return item.address.toString().toLowerCase().includes(this.filterAddressBarrier.toLowerCase());
        });
      }

      return barriers;
    },
    doorphoneCount () {
      if (this.resResidentComplex && this.resResidentComplex.doorphones) {
        return this.resResidentComplex.doorphones.filter(doorphone => doorphone.type === 'M').length;
      }
      return 0;
    },
    gateCount () {
      if (this.resResidentComplex && this.resResidentComplex.doorphones) {
        return this.resResidentComplex.doorphones.filter(doorphone => doorphone.type === 'G').length;
      }
      return 0;
    },
    barrierCount () {
      return this.resResidentComplex.barriers ? this.resResidentComplex.barriers.length : 0;
    },
  },
  methods: {
    ...mapActions({
      getComplex: 'ResidentComplex/getComplex',
      viewComplex: 'ResidentComplex/viewComplex',
      updateComplex: 'ResidentComplex/updateComplex',
      openDoor: 'Doorphone/openDoor',
      openBarrier: 'Barriers/openBarrier',
      openDorGate: 'Gate/openGate',
      makeCall: 'Barriers/makeCall',
    }),
    getPassageType (item) {
      switch (item) {
        case 'B': return ', (Шлагбаум)';
        case 'G': return ', (Ворота)';
        default: return '';
      }
    },
    getOpeningType (item) {
      const labels = {
        C: 'Открытие по звонку',
        RC: 'Открытие по пультам',
        A: 'Приложение EvoLife',
        G: 'Распознавание ГРЗ',
      };
      const values = Array.isArray(item)
        ? item
        : item === 'CG'
          ? ['C', 'G']
          : (item ? String(item).split(',').map(v => v.trim()).filter(Boolean) : []);
      return values.map(v => labels[v]).filter(Boolean).join(', ');
    },
    hasOpeningType (item, type) {
      const values = Array.isArray(item)
        ? item
        : item === 'CG'
          ? ['C', 'G']
          : (item ? String(item).split(',').map(v => v.trim()).filter(Boolean) : []);
      return values.includes(type);
    },
    openDoorClick (item) {
      this.openDoor(item.id)
        .then(() => {
          this.$flash_success('Дверь открыта');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при открытии двери');
        });
    },
    openDeviceClick (item) {
      if (this.hasOpeningType(item.opening_type, 'C') && item.sip_status === null) {
        this.makeCallToOpen(item);
        return;
      }

      if (item.doors.length >= 2) {
        this.showDialogTwoButtons[item.id] = true;
        return;
      }
      this.openDoorBarrier(1, item.id);
    },
    makeCallToOpen (item) {
      const phone = item.barrier_open_phone;

      if (!phone) {
        this.$flash_warning('Добавьте номер телефона для открытия шлагбаума.');
        return;
      }

      this.makeCall({ phone: phone })
        .then(() => {
          this.$flash_success('Звонок успешно инициализирован, шлагбаум открывается');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при открытии шлагбаума');
        });
    },
    handleOpen (relayIndex, id) {
      this.showDialogTwoButtons[id] = false;
      this.openDoorBarrier(relayIndex, id);
    },
    openDoorBarrier (doornum, id) {
      this.openBarrier({
        id: id,
        doornum: doornum,
      })
        .then(() => {
          this.$flash_success('Открыто!');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при открытии');
        });
    },
    cancellation () {
      this.comment = this.resResidentComplex.comment;
    },
    validateKeyUp (e) {
      if (e.keyCode === 13) {
        this.filterDoorphones();
      }
    },
    validate () {
      const doorphonesId = [];
      const doorphonesIdAttached = [];
      this.combinedArrayId = [...new Set([...doorphonesId, ...doorphonesIdAttached])];

      const tempComplex = {
        name: this.resResidentComplex.name,
        coordinates: this.resResidentComplex.coordinates,
        comment: this.comment,
      };

      if (this.resResidentComplex.doorphones) {
        tempComplex.doorphones = this.resResidentComplex.doorphones.id;
      }

      this.updateComplex({
        id: this.$route.params.id,
        value: tempComplex,
      })
        .then(() => {
          this.$flash_success('Изменения успешно сохранены');
          this.getResidentComplex();
        })
        .catch(() => {
          if (this.name) {
            this.$flash_warning(`Ошибка при редактирование ЖК ${this.name}`);
          } else {
            this.$flash_warning('Ошибка при редактирование ЖК');
          }
        });
    },
    getResidentComplex () {
      this.viewComplex(this.$route.params.id)
        .then((res) => {
          this.resResidentComplex = res;
          this.attachedDoorphones = this.resResidentComplex.doorphones.map(doorphone => doorphone.id);
          this.comment = this.resResidentComplex.comment;
          this.name = this.resResidentComplex.name;
        })
        .catch((e) => {
          console.error(e);
          this.$flash_warning('Ошибка при загрузке жилого комплекса');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}
.count-device {
  display: flex;
}
@media screen and (max-width: 550px) {
  .count-device {
    display: block;
  }
  .mobile-text-name {
    width: 200px;
  }
}
</style>
